<form class="waitlist-form" [formGroup]="form" (ngSubmit)="submit()">
  <article class="waitlist-form__card">
    <header class="waitlist-form__summary-header">
      <strong>Waitlist summary</strong>
    </header>

    <div class="waitlist-form__body">
      @if (countryFlag()) {
        <p class="waitlist-form__flag" aria-hidden="true">{{ countryFlag() }}</p>
      }
      <h1 class="waitlist-form__course">
        {{ selection().courseName }}
        @if (locationDisplay()) {
          <span class="waitlist-form__course-sub">{{ locationDisplay() }}</span>
        }
      </h1>

      <section class="waitlist-form__section">
        <h2 class="waitlist-form__section-title">Tee Time</h2>
        <ul class="waitlist-form__meta">
          <li><span aria-hidden="true">📆</span> {{ selection().date | date:'EEE. d MMM yyyy' }}</li>
          <li><span aria-hidden="true">🏌️‍♂️</span> {{ selection().players }} players</li>
          <li><span aria-hidden="true">⛳️</span> {{ selection().holes }} Holes</li>
        </ul>
      </section>

      <section class="waitlist-form__section">
        <h2 class="waitlist-form__section-title">Your details</h2>

        @if (currentUser(); as user) {
          <div class="waitlist-form__contact">
            <span class="waitlist-form__contact-avatar">
              @if (user.imageUrl) {
                <img [src]="user.imageUrl" [alt]="user.name || ''" width="32" height="32">
              } @else {
                <img src="assets/images/userAvatarIcon.svg" alt="" width="32" height="32">
              }
            </span>
            @if (user.name) {
              <span class="waitlist-form__contact-name">{{ user.name }}</span>
            }
          </div>

          @if (user.email) {
            <div class="waitlist-form__field waitlist-form__field--readonly">
              <span class="waitlist-form__field-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.6" />
                  <path d="m3 7 9 6 9-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              <span>{{ user.email }}</span>
            </div>
          }
        }

        <!-- Phone is taken from the user's account and shown read-only (not editable). -->
        @if (selection().phone) {
          <div class="waitlist-form__field waitlist-form__field--readonly">
            <span class="waitlist-form__field-icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
              </svg>
            </span>
            <span>{{ selection().phone }}</span>
          </div>
        }
      </section>

      @if (costSummary(); as cost) {
        <section class="waitlist-form__section">
          <h2 class="waitlist-form__section-title">Cost Summary</h2>
          <ul class="waitlist-form__cost">
            @for (line of cost.perPlayer; track $index) {
              <li>
                <span class="waitlist-form__cost-label">{{ line.label }}</span>
                <span class="waitlist-form__cost-amount waitlist-form__cost-amount--muted">
                  @if (line.displayText) {
                    {{ line.displayText }}
                  } @else {
                    {{ line.amount | currency:currency():'symbol':'1.2-2' }}
                  }
                </span>
              </li>
            }
            <li>
              <span class="waitlist-form__cost-label">Booking fee</span>
              <span class="waitlist-form__cost-amount">
                {{ cost.bookingFee | currency:currency():'symbol':'1.2-2' }}
              </span>
            </li>
          </ul>
          <div class="waitlist-form__total">
            <span class="waitlist-form__total-label">Total due</span>
            <span class="waitlist-form__total-amount">
              {{ cost.totalDue | currency:currency():'symbol':'1.2-2' }}
            </span>
          </div>
        </section>

        @if (cost.payOnsiteOption; as opt) {
          <label class="waitlist-form__onsite">
            <input type="checkbox"
                   class="waitlist-form__onsite-input"
                   formControlName="payOnsiteChecked" />
            <span class="waitlist-form__onsite-body">
              <span class="waitlist-form__onsite-label">{{ opt.label }}</span>
              @if (opt.description) {
                <span class="waitlist-form__onsite-description">{{ opt.description }}</span>
              }
            </span>
          </label>
        }
      }

      <button type="submit"
              class="waitlist-form__cta"
              [disabled]="!interactive() || submitted()">
        {{ submitted() ? 'Adding to waitlist…' : 'Pay Now' }}
      </button>

      @if (termsAndConditions(); as terms) {
        <p class="waitlist-form__terms">
          @if (terms.link) {
            By proceeding with your booking, you acknowledge and accept the
            <a [href]="terms.link" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
            of GOLF.AI service.
          } @else {
            {{ terms.text }}
          }
        </p>
      }
    </div>
  </article>
</form>
